// extracted by mini-css-extract-plugin
export default {"bank-card-preview":"bank-card-preview--brA3xfVXSc","bankCardPreview":"bank-card-preview--brA3xfVXSc","bank-name":"bank-name--VdFyAVM7U+","bankName":"bank-name--VdFyAVM7U+"};